var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadThumbnailQueuedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 22.2243C13.4167 23.0951 14.1292 23.8076 15 23.8076C15.8708 23.8076 16.5833 23.0951 16.5833 22.2243C16.5833 21.3535 15.8708 20.641 15 20.641C14.1292 20.641 13.4167 21.3535 13.4167 22.2243ZM13.4167 0.0576172V6.39095H16.5833V3.35095C21.9508 4.12678 26.0833 8.71845 26.0833 14.3076C26.0833 20.4351 21.1275 25.391 15 25.391C8.8725 25.391 3.91667 20.4351 3.91667 14.3076C3.91667 11.6476 4.85083 9.20928 6.41833 7.30928L15 15.891L17.2325 13.6585L6.46583 2.89178V2.92345C2.99833 5.52012 0.75 9.63678 0.75 14.3076C0.75 22.1768 7.115 28.5576 15 28.5576C22.8692 28.5576 29.25 22.1768 29.25 14.3076C29.25 6.43845 22.8692 0.0576172 15 0.0576172H13.4167ZM24.5 14.3076C24.5 13.4368 23.7875 12.7243 22.9167 12.7243C22.0458 12.7243 21.3333 13.4368 21.3333 14.3076C21.3333 15.1785 22.0458 15.891 22.9167 15.891C23.7875 15.891 24.5 15.1785 24.5 14.3076ZM5.5 14.3076C5.5 15.1785 6.2125 15.891 7.08333 15.891C7.95417 15.891 8.66667 15.1785 8.66667 14.3076C8.66667 13.4368 7.95417 12.7243 7.08333 12.7243C6.2125 12.7243 5.5 13.4368 5.5 14.3076Z",
    fill: "#A0CDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadThumbnailQueuedIcon);
export default __webpack_public_path__ + "static/media/UploadThumbnailQueuedIcon.6ee4ca03.svg";
export { ForwardRef as ReactComponent };